import { Metamodel } from '../base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';

import { AzureMariaDBLinkedService } from '../linkedservice/azure-maria-db.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { IModel } from '../base/annotation';

@Metamodel.model({
    name: adfModelTypeMap.azureMariaDB.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.AzureMariaDB_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.AzureMariaDB_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: AzureMariaDBLinkedService.MODEL // Linked service redefined
        }
    }
})
export class AzureMariaDBTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
